import React, { useState } from 'react';
import { AdminSidebar } from '../components/admin/AdminSidebar';
import { AdminHeader } from '../components/admin/AdminHeader';
interface AdminLayoutProps {
  children: React.ReactNode;
}
export function AdminLayout({
  children
}: AdminLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <div className="flex h-screen bg-gray-50" data-id="element-1533">
      {/* Sidebar - hidden on mobile */}
      <div className="hidden md:block" data-id="element-1534">
        <AdminSidebar data-id="element-1535" />
      </div>
      {/* Mobile sidebar - shown when menu is clicked */}
      {sidebarOpen && <div className="fixed inset-0 z-40 md:hidden" data-id="element-1536">
          <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-1537"></div>
          <div className="relative flex flex-col w-full max-w-xs pb-12 overflow-y-auto bg-white" data-id="element-1538">
            <AdminSidebar mobile onClose={() => setSidebarOpen(false)} data-id="element-1539" />
          </div>
        </div>}
      <div className="flex flex-col flex-1 w-0 overflow-hidden" data-id="element-1540">
        <AdminHeader onMenuClick={() => setSidebarOpen(true)} data-id="element-1541" />
        <main className="relative flex-1 overflow-y-auto focus:outline-none" data-id="element-1542">
          <div className="py-6" data-id="element-1543">
            <div className="px-4 mx-auto max-w-7xl sm:px-6 md:px-8" data-id="element-1544">
              {children}
            </div>
          </div>
        </main>
      </div>
    </div>;
}